import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { ORIGIN } from '@sorare/core/src/config';
import {
  FOOTBALL,
  FOOTBALL_BESTOFEUROPE,
  FOOTBALL_CAMPAIGNS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import useIsLoggedIn from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { Hero } from 'pages/bestofeurope/Hero';
import { Howto } from 'pages/bestofeurope/Howto';
import { Needsyou } from 'pages/bestofeurope/Needsyou';
import { Pick } from 'pages/bestofeurope/Pick';
import { Win } from 'pages/bestofeurope/Win';
import backgroundAvif from 'pages/bestofeurope/assets/background.avif';
import background from 'pages/bestofeurope/assets/background.jpg';

const Wrapper = styled(Vertical)`
  /** necessary for the ribon that add a scroll bar becore of its slight rotation */
  overflow: hidden;
`;

const Background = styled(Vertical)`
  gap: calc(10 * var(--unit));
  background-image: url(${background}});
  background-image: image-set(
    url(${backgroundAvif}) type('image/avif'),
    url(${background})
  );
  background-size: cover;
  background-position: center;
`;

const BestOfEurope = () => {
  const {
    flags: { useBestOfEurope = false },
  } = useFeatureFlags();
  const { signUp } = useConnectionContext();
  const isLoggedIn = useIsLoggedIn();

  if (!useBestOfEurope) {
    return <Navigate to={FOOTBALL} />;
  }
  if (isLoggedIn) {
    return <Navigate to={FOOTBALL_CAMPAIGNS} />;
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href={`${ORIGIN}${FOOTBALL_BESTOFEUROPE}`} />
      </Helmet>
      <Wrapper gap={0}>
        <Hero signUp={signUp} />
        <Needsyou signUp={signUp} />
        <Background>
          <Howto signUp={signUp} />
          <Win />
        </Background>
        <Pick signUp={signUp} />
      </Wrapper>
    </>
  );
};
export default BestOfEurope;
